export enum State {
  LOADING,
  ERROR,
  SUCCESS,
}
